<template>
    <div>
        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
            :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }" :columns="table.columns" :rows="table.rows">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'status'">
                    <span v-if="props.row.status === 'sent'" class="badge badge-success">Terkirim</span>
                    <span v-else-if="props.row.status === 'failed'" class="badge badge-danger">Gagal</span>
                    <span v-else class="badge badge-warning text-white">Pending</span>
                </span>
                <span v-else-if="props.column.field == 'sent_at'">
                    {{ formatSentAt(props.row.sent_at) }}
                </span>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        return {
            table: {
                isLoading: false,
                columns: [
                    { label: 'Nama', field: 'contact.name', sortable: false },
                    { label: 'Nomor', field: 'contact.number', sortable: false },
                    { label: 'Status', field: 'status', sortable: false },
                    { label: 'Waktu Kirim', field: 'sent_at', sortable: false },
                    // { label: 'Error', field: 'error_message', sortable: false }
                ],
                rows: [],
                total_records: 0,
                serverParams: {
                    page: 1,
                    limit: 10
                }
            }
        };
    },
    methods: {
        async loadItems() {
            this.table.isLoading = true;
            try {
                let response = await this.$store.dispatch("birthday/birthday_logs", this.table.serverParams);
                this.table.rows = response.data.data.logs || [];
                this.table.total_records = response.data.data.total_records || 0;
            } catch (err) {
                this.$toast.error("Gagal memuat data");
            }
            this.table.isLoading = false;
        },
        updateParams(newProps) {
            this.table.serverParams = Object.assign({}, this.table.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ limit: params.currentPerPage });
            this.loadItems();
        },
        onSortChange() {
            this.loadItems();
        },
        onColumnFilter(params) {
            this.updateParams(params);
            this.loadItems();
        },
        formatSentAt(timestamp) {
            if (!timestamp) return '-';
            
            // Convert unix milliseconds to moment
            const date = moment(timestamp);
            if (!date.isValid()) return '-';
            
            // Format: "01 Januari 2003, 14:30" (Indonesian format with month name)
            const months = [
                "Januari", "Februari", "Maret", "April", "Mei", "Juni",
                "Juli", "Agustus", "September", "Oktober", "November", "Desember"
            ];
            
            const day = String(date.date()).padStart(2, '0');
            const month = months[date.month()];
            const year = date.year();
            const time = date.format('HH:mm');
            
            return `${day} ${month} ${year}, ${time}`;
        }
    },
    mounted() {
        this.loadItems();
    }
};
</script>

